import { PlatformPage } from './PlatformPage'
import { StaffRolesTab } from './tabs/StaffRolesTab'

export function StaffRolesPage() {
  return (
    <PlatformPage
      title="Staff Roles"
      description="Platform-scope roles and their admin.* permission assignments."
    >
      <StaffRolesTab />
    </PlatformPage>
  )
}
